import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { fetchEducationals } from '../api/api'; 
import { CircularProgress } from '@material-ui/core';


import Item from './Item';



const styles = theme => ({
  root: {
    margin: '30px 0px'
  }
});

class Educationals extends Component {

  state = {
    educationals: [],
    isLoading: false
  }
  
  componentDidMount() {
    this.loadEducationals(); 
  }

  loadEducationals = async () => {
   this.setState({isLoading: true});
   const educationals =  await fetchEducationals({
   }); 
   this.setState({educationals, isLoading: false});
  }


  render() {
    const { classes } = this.props;
    const { educationals, isLoading } = this.state;
    if (isLoading) {
      return <CircularProgress />
    }
    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="flex-start"
        >
          {educationals.map(educational => (
          <Item key={educational._id} 
          section={educational} 
          clickable width={4}
          onClick={() => this.openLink(educational.educational.url)}
          type="photo" /> ))}
        </Grid>
      </div>
    )
  }
}

Educationals.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Educationals);
